import ReactDOM from 'react-dom';

import { ThemeProvider } from '@mui/material/styles';
import { App } from './App';
import { GlobalStyle, theme } from './styles';
import { initI18n } from './locale/i18n';

initI18n();

ReactDOM.render(
    <>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </>,
    document.getElementById('root')
);
